/**
 * Project and task status as the design's five tones.
 *
 * The screens used to carry their own Tailwind colour map (bg-blue-100 for
 * in_progress, bg-amber-100 for on_hold and so on), which meant "waiting" was a
 * different amber here than on every other CRM list. StatusPill already owns
 * that meaning, so a status only has to say which of the five tones it is.
 */
import type { StatusTone } from "../../ui";
import type { ProjectStatus, TaskStatus } from "../../../lib/projects";
import type { RoadmapCol } from "./lib";

export const STATUSES: ProjectStatus[] = ["not_started", "in_progress", "on_hold", "completed", "cancelled"];
export const TASK_STATUSES: TaskStatus[] = ["todo", "in_progress", "review", "done"];

/** ok = done, info = moving, wt = waiting on somebody, lt = called off, mut = not begun. */
const PROJECT_TONE: Record<ProjectStatus, StatusTone> = {
  not_started: "mut",
  in_progress: "info",
  on_hold: "wt",
  completed: "ok",
  cancelled: "lt",
};

export function statusTone(s: ProjectStatus): StatusTone {
  return PROJECT_TONE[s];
}

const TASK_TONE: Record<TaskStatus, StatusTone> = {
  todo: "mut",
  in_progress: "info",
  review: "wt",
  done: "ok",
};

export function taskTone(s: TaskStatus): StatusTone {
  return TASK_TONE[s];
}

/** A roadmap column reads as the state it collects, so the card pills and the
 *  list pills agree with each other across the two views. */
const COLUMN_TONE: Record<RoadmapCol, StatusTone> = {
  completed: "ok",
  in_progress: "info",
  planned: "wt",
  future: "mut",
};

export function columnTone(c: RoadmapCol): StatusTone {
  return COLUMN_TONE[c];
}
